import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of, Subscription} from "rxjs";
import {catchError} from "rxjs/operators";

export class VirtualDataSource extends DataSource<any> {
  private _fetchedPages = new Set<number>();
  private totalPages = 1;
  private _cachedData: any[] = [];
  private readonly _dataStream = new BehaviorSubject<any[]>([]);
  private readonly _subscription = new Subscription();

  constructor(
    private apiGetItems: (params: any) => Observable<any>,
    private pageSize: number = 20,
    private pageStart: number = 1,
  ) {
    super();
  }


  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    this._fetchPage(this.pageStart);
    this._subscription.add(
      collectionViewer.viewChange.subscribe(range => {
        const endPage = this._getPageForIndex(range.end);
        if (endPage < this.totalPages) {
          this._fetchPage(endPage + 1)
        }
      }),
    );
    return this._dataStream;
  }

  disconnect(): void {
    this._subscription.unsubscribe();
  }

  private _getPageForIndex(index: number): number {
    return Math.floor(index / this.pageSize);
  }

  private _fetchPage(page: number) {
    if (this._fetchedPages.has(page)) {
      return;
    }
    this._fetchedPages.add(page);
    this.apiGetItems({page: page, size: this.pageSize})
      .pipe(catchError(() => of([])))
      .subscribe(
        (resp) => {
          if (!this._cachedData.length && resp?.data.totalElements) {
            this._cachedData = Array.from({length: resp?.data.totalElements})
          }
          this.totalPages = resp?.data?.totalPages
          this._cachedData.splice((this.pageStart > 0 ? page - 1 : page) * this.pageSize, this.pageSize, ...(resp?.data?.content || []));
          this._dataStream.next(this._cachedData);
        }
      )
  }
}
